<template>
  <div class="">
  <div class="col-sm-12 favourites_text">
    <div class="distance_tracker">
      <div class="progress">
        <div class="progress-bar" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" v-bind:style="percentWidth"><span class="slider_icon icon-athlete"></span>
          </div>
        </div>
      <span class="distance_covered" id="athletedistcovered">{{distance}} km</span>
      <span class="pull-right"><span class="distance_end" id="athletedistend">{{distToGo}} km to go</span> <span class="icon-finish"></span></span>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
export default{
  data: function () {
    return {
    }
  },
  props: [
    'currentDistance',
    'totalDistance'
  ],
  computed: {
    distance: function () {
      var progdis = (this.currentDistance / 1000.0).toFixed(1)
      // if(progdis > this.totalDistance){
      //   progdis = 0.0
      // }
      return progdis
    },
    distToGo: function () {
      var progdistogo = ((this.totalDistance - this.currentDistance) / 1000.0).toFixed(1)
      // if(progdistogo < 0.0){
      //   progdistogo = 0.0
      // }
      return Math.abs(progdistogo)
    },
    percentWidth: function () {
      var progwid = ((this.currentDistance / this.totalDistance) * 100.0).toFixed(1)
      if (progwid > 100.0) {
        progwid = 100.0
      }
      return {
        width: progwid + '%'
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/progressbar.vue